import Buttons from '../../elements/modal/genericAcceptModalButtons';
import Container from '../../atoms/container/modalContainer';
import Title from '../../atoms/text/modalTitle';

interface TwoOptionsModalProps {
  title: string;
  acceptAction?: () => void;
  cancelAction?: () => void;
  allowedBack?: boolean;
  acceptButtonText?: string;
  cancelButtonText?: string;
}

function TwoOptionsModal({
  title,
  acceptAction,
  cancelAction,
  allowedBack = true,
  acceptButtonText = 'MODAL.GENERIC_ACCEPT_BUTTONS.YES',
  cancelButtonText = 'MODAL.GENERIC_ACCEPT_BUTTONS.NO',
}: TwoOptionsModalProps) {
  return (
    <Container>
      <Title>{title}</Title>
      <Buttons
        acceptAction={acceptAction}
        cancelAction={cancelAction}
        allowedBack={allowedBack}
        acceptButtonText={acceptButtonText}
        cancelButtonText={cancelButtonText}
      />
    </Container>
  );
}

export default TwoOptionsModal;
